<template>
  <div class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <WdsText size="sm" weight="medium" class="tw-truncate">{{ batchNames }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestBatchColumn = graphql(`
  fragment PaymentRequestBatchColumn on PaymentRequest {
    id
    batches {
      data {
        id
        name
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestBatchColumn>
}>()

const column = computed(() => useFragment(PaymentRequestBatchColumn, props.row))

const batchNames = computed(() => {
  const batches = column.value.batches?.data || []
  return batches.map((batch) => batch.name).join(', ') || 'No batch'
})
</script>

<style scoped></style>
